"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const settingPCCStates_1 = require("./settingPCCStates");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const _1 = require(".");
function default_1({ deliverySettingData, settingPCCForm, }) {
    const { second_customvalue, default_delivery } = deliverySettingData;
    const hasSavedPCC = Boolean(second_customvalue);
    const isVerifyPCCPending = (0, recoil_1.useRecoilValue)(settingPCCStates_1.isVerifyPCCPendingState);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            columnGap: '8px',
            flexWrap: 'wrap',
            '> *': {
                display: 'flex',
                alignItems: 'center',
                columnGap: '4px',
                flexShrink: 0,
            },
        } }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "gray-80", css: { display: hasSavedPCC ? 'none' : 'flex', cursor: 'pointer' }, onClick: (0, _1.verifyPCC)({ default_delivery, settingPCCForm }) }, { children: [isVerifyPCCPending ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 10, thickness: 6, color: "secondary", sx: { marginRight: '3px' } })) : ((0, jsx_runtime_1.jsx)(svgs_1.CheckIconSvg, { css: { width: '16px', height: '16px' } })), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "caption1" }, { children: t('유효체크') }))] })), (0, jsx_runtime_1.jsx)("span", { css: {
                    display: hasSavedPCC ? 'none' : 'flex',
                    height: '10px',
                    borderLeft: '1px solid rgba(0, 0, 0, 0.2)',
                } }), (0, jsx_runtime_1.jsxs)("a", Object.assign({ className: "no_anchor_deco gray-80", target: "_blank", rel: "noopener noreferrer", href: "https://unipass.customs.go.kr/csp/persIndex.do" }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.ArrowRightCirclineBlackSvg, { css: { width: '16px', height: '16px' } }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "subtitle5" }, { children: t('발급 받기') }))] }))] })));
}
exports.default = default_1;
